// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"77a254b9","752":"5757de62"}[chunkId] + ".chunk.js";
};